import React from "react"
import { Radio as MUIRadio, RadioProps } from "@mui/material"
import { CheckedState, UncheckedState } from "./icons"

const Radio: React.FC<RadioProps> = React.forwardRef<any, RadioProps>(
  (props, ref) => {
    return (
      <MUIRadio
        {...props}
        ref={ref}
        icon={<UncheckedState />}
        checkedIcon={<CheckedState />}
      />
    )
  }
)

export default Radio
